module.exports = __webpack_public_path__ + "img/IMG_9925.6e7ee233.jpg";